function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, "\n            .cls-1,.primary{fill:none;}.white{fill:#fff;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("polygon", {
  className: "white",
  points: "127.01 27 159.46 92.74 232 103.28 179.51 154.45 191.9 226.7 127.01 192.58 62.13 226.7 74.52 154.45 22.03 103.28 94.57 92.74 127.01 27"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("polygon", {
  className: "primary",
  points: "127.01 27 159.46 92.74 232 103.28 179.51 154.45 191.9 226.7 127.01 192.58 62.13 226.7 74.52 154.45 22.03 103.28 94.57 92.74 127.01 27"
})));
var SvgBasicStar = function SvgBasicStar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBasicStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BasicStar.7d46a4f3.svg";
export { ForwardRef as ReactComponent };